module.exports = __webpack_public_path__ + "static/media/IMG_2213_Original.f79caf5b.jpg";